export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10309.15e03b39.jpg";